import {VariantConfigT} from '@/lib/types/colors.types';

export const indigoConfig: VariantConfigT = {
  basic: {
    icon: 'indigo',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'indigo',
    active: 'indigo',
  },
  outline: {
    icon: 'indigo',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  ghost: {
    icon: 'indigo',
    iconHover: 'indigo',
    iconActive: 'indigo',
    hover: 'indigo',
    active: 'indigo',
  },
  gradient: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  solid: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
};
